<div class="dictionarysearch" (click)="onClick()">
    <i class="material-icons">search</i> {{ 'CONTEXTMENU.DICTIONARYSEARCH' | translate }}
</div>